'use strict'

export default function ResolveProductPricing({ cart, attributes, id, isRemoveFromCartAction = false }) {
  const productDiscountAvailable = {
    saleOff: cart.isSaleOff && attributes.isSaleOffApplicable,
    cld: !cart.isCLDDisabled && attributes.isCLDApplicable
  }

  if ((productDiscountAvailable.saleOff) && attributes.saleOffDiscount !== 0) {
    const discountedPrice = attributes.price * (100 - attributes.saleOffDiscount) / 100.0

    return {
      price:          discountedPrice,
      originalPrice:  attributes.price,
      discount:       1.0 - discountedPrice / attributes.price,
      discountAmount: attributes.price - discountedPrice,
      ribbon:         'saleOff'
    }
  } else if (productDiscountAvailable.cld) {
    const isCartSizeSufficient = (cart.itemIds?.includes(attributes.id) ? cart.value : cart.value + attributes.price) >= cart.applicableCldValue

    const checkIfLoggedIn = () => {
      if (typeof window !== 'undefined') {
        // take user id from APP.config.userId - for slow application
        // or from window.pageConfig.currentUserId - for fast application
        return window.App?.config?.userId || window.pageConfig?.currentUserId
      }

      return false
    }

    if (isCartSizeSufficient && checkIfLoggedIn()) {
      let discountedPrice = Math.max(
        attributes.price - cart.creditsAvailable,
        attributes.price * 0.7
      )

      return {
        price:          discountedPrice,
        originalPrice:  attributes.price,
        discount:       1.0 - discountedPrice / attributes.price,
        discountAmount: attributes.price - discountedPrice,
        ribbon:         'CLD'
      }
    } else {
      return {
        price:          attributes.price,
        originalPrice:  attributes.price,
        discount:       0,
        discountAmount: 0,
        ribbon:         'CLD'
      }
    }
  } else {
    return {
      price:          attributes.price,
      originalPrice:  attributes.price,
      discount:       0,
      discountAmount: 0,
    }
  }
}
